import { Component, OnInit, Inject, Input } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import {Observable} from "rxjs";
import { Event } from '../../models/event';
import { EventService } from '../../services/event.service';
import { TypeEventService } from '../../services/type-event.service';
import * as esLocale from "date-fns";
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';

@Component({
  selector: 'app-video-dialog',
  templateUrl: './video-dialog.component.html',
  styleUrls: ['./video-dialog.component.css']
})
export class VideoDialogComponent implements OnInit {
  videoUrl: SafeResourceUrl;
  constructor (public sanitizer:DomSanitizer,
    @Inject(MD_DIALOG_DATA) public data: any,
    public dialogRef: MdDialogRef<VideoDialogComponent>) {
      this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + this.data.id + '?modestbranding=1&rel=0&showinfo=0&loop=1&autoplay=1&cc_load_policy=0&iv_load_policy=0&autohide=1&mode=opaque');
    }

  ngOnInit() {
      this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + this.data.id + '?modestbranding=1&rel=0&showinfo=0loop=1&autoplay=1&cc_load_policy=0&iv_load_policy=0&autohide=1&mode=opaque');
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/video-dialog/video-dialog.component.ts